import { z } from "zod";

export const createSponsoredContentSchema = z
	.object({
		image_url: z.url({ message: "Invalid image URL" }),
		cta_url: z.url({ message: "Invalid CTA URL" }),
		cta_label: z.string().max(100).optional(),
	})
	.strict();

export type CreateSponsoredContentPayload = z.infer<typeof createSponsoredContentSchema>;
